'use client';

import { footerLinkGdpr, navCookies, navPrivacy, navTerms } from 'Workadabra/translations';
import { NavDock, type NavDockItem } from '@bomdisoft/components';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export const LegalNavDock = () => {
  const params = useParams();
  const langPrefix = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(langPrefix);

  const items: NavDockItem[] = [
    { href: `/${langPrefix}/privacy-policy`, label: navPrivacy[language], matchPaths: [`/${langPrefix}/privacy-policy`], testId: 'legal-link-privacy' },
    { href: `/${langPrefix}/terms-of-service`, label: navTerms[language], matchPaths: [`/${langPrefix}/terms-of-service`], testId: 'legal-link-terms' },
    { href: `/${langPrefix}/cookie-policy`, label: navCookies[language], matchPaths: [`/${langPrefix}/cookie-policy`], testId: 'legal-link-cookies' },
    { href: `/${langPrefix}/gdpr`, label: footerLinkGdpr[language], matchPaths: [`/${langPrefix}/gdpr`], testId: 'legal-link-gdpr' },
  ];

  return <NavDock items={items} testId='legal-nav-dock' />;
};
